import { Children } from 'react'

const FormSelect = (props) => {
    return (
        <div className={`relative flex ${props.displayRow ? 'flex-row items-center' : 'flex-col'}`}>
            <select
                disabled={props.isDisabled}
                id={props.idValue}
                name={props.name}
                autoComplete={props.autoComplete}
                className="order-2 block w-auto py-2 text-gray-900 border-0 rounded-md shadow-sm peer ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-secondary sm:text-sm sm:leading-6 invalid:ring-red disabled:ring-gray-200 disabled:bg-gray-100 disabled:text-gray-500 disabled:cursor-not-allowed"
                value={props.value}
                onChange={props.onChange}
            >
                {Children.map(props.children, (child) => (
                    <option key={child?.props.value} value={child?.props.value} disabled={child?.props.disabled}>
                        {child.props.children}
                    </option>
                ))}
            </select>

            {props.errorMsg ? (
                <p className='mt-2 order-3 invisible peer-placeholder-shown:!invisible peer-placeholder-shown:!h-px peer-invalid:visible peer-invalid:h-4 h-px text-red text-sm transition-all'>
                    {props.errorMsg}
                </p>
            ) : null}

            {props.label ? (
                <label
                    htmlFor={props.idValue}
                    className={
                        props.showLabel
                            ? `p order-1 block text-sm font-medium leading-6 text-gray-900 peer-invalid:text-red ${props.displayRow ? 'mr-2' : 'mb-2'}`
                            : 'sr-only'
                    }
                >
                    {props.label} {props.required ? <span className="text-red-500">*</span> : props.showOptionalLabel !== false && <span className="ml-3 text-xs text-gray-500"> (optional)</span>}
                </label>
            ) : null}
        </div>
    )
}

export default FormSelect
